// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"41":"9b88c7e6","375":"ddc5204a","424":"c54371a3","531":"2679e4a3","918":"448569e7"}[chunkId] + ".css";
};